
import React, { useEffect, useState } from "react";
import { authApi } from "../../api";
import toast from "react-hot-toast";

export default function ResetPassCode() {
    const [timer, setTimer] = useState(300);
    const [code, setCode] = useState("");
    const [email, setEmail] = useState(""); // Eğer email'i context veya prop ile taşıyamıyorsan localStorage ile sakla

    const [timerResetKey, setTimerResetKey] = useState(0); // 🔧 yeni eklendi



    // useEffect(() => {
    //     if (timer <= 0) return; // Sayaç sıfıra düştüyse interval başlatma
    //
    //     const interval = setInterval(() => {
    //         setTimer(prev => prev - 1);
    //     }, 1000);
    //
    //     return () => clearInterval(interval); // Her render’da eski intervali temizler
    // }, [timer]);



    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setTimer(prev => {
    //             if (prev <= 1) {
    //                 clearInterval(interval);
    //                 return 0;
    //             }
    //             return prev - 1;
    //         });
    //     }, 1000);
    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timerResetKey]); // 🟡 timer değil, timerResetKey





    useEffect(() => {
        const storedEmail = localStorage.getItem("resetEmail");
        if (storedEmail) setEmail(storedEmail);
    }, []);


    // useEffect(() => {
    //     const el = document.getElementById("resetPassCode");
    //     if (!el || !window.bootstrap?.Offcanvas) return;
    //
    //     const handleShown = () => {
    //         setCode("");         // input'u temizle
    //         setTimer(300);       // sayaç da sıfırlansın istiyorsan
    //     };
    //
    //     el.addEventListener("shown.bs.offcanvas", handleShown);
    //
    //     return () => {
    //         el.removeEventListener("shown.bs.offcanvas", handleShown);
    //     };
    // }, []);


    // useEffect(() => {
    //     const el = document.getElementById("resetPassCode");
    //     if (!el) return;
    //
    //     const onShow = () => setCode(""); setTimer(300); // Açıldığında kod temizle
    //
    //     el.addEventListener("shown.bs.offcanvas", onShow);
    //     return () => el.removeEventListener("shown.bs.offcanvas", onShow);
    // }, []);
    useEffect(() => {
        const el = document.getElementById("resetPassCode");
        if (!el) return;

        const onShow = () => {
            setCode("");
            setTimer(300);                  // ⬅ timer'ı sıfırla
            setTimerResetKey(prev => prev + 1);  // ⬅ timer'ı yeniden başlat
        };

        el.addEventListener("shown.bs.offcanvas", onShow);
        return () => el.removeEventListener("shown.bs.offcanvas", onShow);
    }, []);





    const handleVerify = async (e) => {
        e.preventDefault();
        try {
            await authApi.verifyResetCode({ email, code });
            toast.success("Code verified!");

            // Modal geçişi
            const current = window.bootstrap?.Offcanvas.getInstance(document.getElementById("resetPassCode"));
            current?.hide();

            setCode("");

            setTimeout(() => {


                const el = document.getElementById("newPasswordModal");

                if (window.bootstrap && el) {
                    const nextCanvas = new window.bootstrap.Offcanvas(el);
                    nextCanvas.show();
                }
            }, 400);
        } catch (err) {
            toast.error(err.response?.data?.message || "Code verification failed.");
        }
    };

    const formatTime = () => {
        const minutes = String(Math.floor(timer / 60)).padStart(2, "0");
        const seconds = String(timer % 60).padStart(2, "0");
        return `${minutes}:${seconds}`;
    };

    return (
        <div className="offcanvas offcanvas-end popup-style-1 input-page" id="resetPassCode" >
            <div className="canvas-wrapper">
                <div className="canvas-header popup-header">
                    <span className="title">Enter Verification Code</span>

                </div>
                <div className="canvas-body popup-inner">
                    <form onSubmit={handleVerify} className="form-login">
                        <p className="text text-sm text-main-2">
                            A 6-digit code was sent to your email. Time left: <strong>{formatTime()}</strong>
                        </p>
                        <fieldset className="text mb_12">
                            <input
                                type="text"
                                placeholder="Enter 6-digit code"
                                maxLength={6}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                required
                            />
                        </fieldset>
                        <div className="button-wrap">
                            <button
                                disabled={timer === 0}
                                className="subscribe-button tf-btn animate-btn bg-dark-2 w-100"
                                type="submit"
                            >
                                Verify
                            </button>

                            <button type="button" data-bs-dismiss="offcanvas"
                                    className="tf-btn btn-out-line-dark2 w-100">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
